var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9284 59.1419C28.4778 59.6913 29.223 60 30 60C30.777 60 31.5222 59.6913 32.0716 59.1419C32.621 58.5925 32.9297 57.8473 32.9297 57.0703V32.9297H57.0703C57.8473 32.9297 58.5925 32.621 59.1419 32.0716C59.6913 31.5222 60 30.777 60 30C60 29.223 59.6913 28.4778 59.1419 27.9284C58.5925 27.379 57.8473 27.0703 57.0703 27.0703H32.9297V2.92969C32.9297 2.15269 32.621 1.40751 32.0716 0.858086C31.5222 0.308663 30.777 0 30 0C29.223 0 28.4778 0.308663 27.9284 0.858086C27.379 1.40751 27.0703 2.15269 27.0703 2.92969V27.0703H2.92969C2.15269 27.0703 1.40751 27.379 0.858086 27.9284C0.308663 28.4778 0 29.223 0 30C0 30.777 0.308663 31.5222 0.858086 32.0716C1.40751 32.621 2.15269 32.9297 2.92969 32.9297H27.0703V57.0703C27.0703 57.8473 27.379 58.5925 27.9284 59.1419Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPlus);
export default __webpack_public_path__ + "static/media/big-plus.090ced0e92796550cbb6d5d3bb97064d.svg";
export { ForwardRef as ReactComponent };